// utils/getDistance.ts
const R = 6_371_000;               // earth radius in metres
const toRad = (d: number) => d * Math.PI / 180;

/** Returns distance in metres between two WGS‑84 points */
export function metresBetween(lat1: number, lon1: number,
                              lat2: number, lon2: number): number {
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a = Math.sin(dLat / 2) ** 2 +
            Math.cos(toRad(lat1)) *
            Math.cos(toRad(lat2)) *
            Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}